import { Flex, FlexProps } from '@chakra-ui/react';
import React, { FunctionComponent as FC } from 'react';
import { MdConstruction } from 'react-icons/md';
import { MBox, MIcon } from './chakra';
import { MTooltip, MTooltipProps } from './MTooltip';

interface MComingSoonWrapperProps extends FlexProps {
  label?: string;
  placement?: MTooltipProps['placement'];
  iconDisplay?: string;
  children?: React.ReactNode;
}

export const MComingSoonWrapper: FC<MComingSoonWrapperProps> = React.forwardRef<
  any,
  MComingSoonWrapperProps
>((props: MComingSoonWrapperProps, ref) => {
  const {
    label = 'Coming Soon',
    placement = 'bottom-end',
    iconDisplay = 'none',
    children,
    ...rest
  } = props;

  return (
    <MTooltip label={label} placement={placement}>
      <Flex
        alignItems="center"
        cursor="pointer"
        role="group"
        className="group"
        {...rest}
      >
        {children}
        <MBox minW="4" ml={2}>
          <MIcon
            color="tGray.lightPurple"
            as={MdConstruction}
            _groupHover={{ display: 'block' }}
            display={iconDisplay}
          />
        </MBox>
      </Flex>
    </MTooltip>
  );
});

export default MComingSoonWrapper;
